import { Navigate, Route, Routes } from 'react-router-dom'
import { CatchAllRoute } from '../components/auth/CatchAllRoute'
import { GuestRoute } from '../components/auth/GuestRoute'
import { PermissionRoute } from '../components/auth/PermissionRoute'
import { ProtectedRoute } from '../components/auth/ProtectedRoute'
import { DASHBOARD_ROUTE_PATHS } from '../config/navigation'
import { AdminSupportPage } from '../pages/AdminSupportPage'
import { AccountStatusPage } from '../pages/AccountStatusPage'
import { CaseCreatePage } from '../pages/CaseCreatePage'
import { CaseDetailPage } from '../pages/CaseDetailPage'
import { CaseEditPage } from '../pages/CaseEditPage'
import { CasesPage } from '../pages/CasesPage'
import { ComorbiditiesPage } from '../pages/ComorbiditiesPage'
import { ComplicationsPage } from '../pages/ComplicationsPage'
import { DashboardPage } from '../pages/DashboardPage'
import { DepartmentsPage } from '../pages/DepartmentsPage'
import { DoctorApprovalsPage } from '../pages/DoctorApprovalsPage'
import { DoctorAssistantsPage } from '../pages/DoctorAssistantsPage'
import { DoctorSignupPage } from '../pages/DoctorSignupPage'
import { HospitalsPage } from '../pages/HospitalsPage'
import { LoginPage } from '../pages/LoginPage'
import { NationalHubDetailPage } from '../pages/NationalHubDetailPage'
import { NationalHubPage } from '../pages/NationalHubPage'
import { NotificationsPage } from '../pages/NotificationsPage'
import { PasswordManagementPage } from '../pages/PasswordManagementPage'
import { PositionsPage } from '../pages/PositionsPage'
import { ProceduresPage } from '../pages/ProceduresPage'
import { ProfilePage } from '../pages/ProfilePage'
import { ReviewInboxPage } from '../pages/ReviewInboxPage'
import { ReviewersPage } from '../pages/ReviewersPage'
import { RolesPage } from '../pages/RolesPage'
import { SupportPage } from '../pages/SupportPage'
import { UpdateCredentialsPage } from '../pages/UpdateCredentialsPage'
import { VerifyOtpPage } from '../pages/VerifyOtpPage'

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<GuestRoute />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/verify-otp" element={<VerifyOtpPage />} />
        <Route path="/doctor/signup" element={<DoctorSignupPage />} />
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route path="/account-status" element={<AccountStatusPage />} />

        {DASHBOARD_ROUTE_PATHS.map((path) => (
          <Route key={path} path={path} element={<DashboardPage />} />
        ))}

        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/roles" element={<RolesPage />} />
        <Route path="/update-credentials" element={<UpdateCredentialsPage />} />
        <Route path="/password-management" element={<PasswordManagementPage />} />
        <Route path="/admin/reviewers" element={<ReviewersPage />} />
        <Route path="/admin/hospitals" element={<HospitalsPage />} />
        <Route path="/admin/departments" element={<DepartmentsPage />} />
        <Route path="/admin/positions" element={<PositionsPage />} />
        <Route path="/admin/procedures" element={<ProceduresPage />} />
        <Route path="/admin/comorbidities" element={<ComorbiditiesPage />} />
        <Route path="/admin/complications" element={<ComplicationsPage />} />
        <Route element={<PermissionRoute permission="doctors-list" />}>
          <Route path="/admin/doctor-approvals" element={<DoctorApprovalsPage />} />
        </Route>
        <Route path="/doctor/assistants" element={<DoctorAssistantsPage />} />

        <Route element={<PermissionRoute permission="cases-list" />}>
          <Route path="/cases" element={<CasesPage />} />
        </Route>

        <Route element={<PermissionRoute permission="cases-create" />}>
          <Route path="/cases/new" element={<CaseCreatePage />} />
        </Route>

        <Route element={<PermissionRoute permission="cases-update" />}>
          <Route path="/cases/:id/edit" element={<CaseEditPage />} />
        </Route>

        <Route element={<PermissionRoute permission="cases-show" />}>
          <Route path="/cases/:id" element={<CaseDetailPage />} />
        </Route>

        <Route element={<PermissionRoute permission="cases-review-inbox" />}>
          <Route path="/review-inbox" element={<ReviewInboxPage />} />
        </Route>

        <Route element={<PermissionRoute permission="national-hub-list" />}>
          <Route path="/national-hub" element={<NationalHubPage />} />
        </Route>

        <Route element={<PermissionRoute permission="national-hub-show" />}>
          <Route path="/national-hub/:id" element={<NationalHubDetailPage />} />
        </Route>

        <Route element={<PermissionRoute permission="support-requests-list" />}>
          <Route path="/support" element={<SupportPage />} />
        </Route>

        <Route element={<PermissionRoute permission="support-requests-list-all" />}>
          <Route path="/admin/support" element={<AdminSupportPage />} />
        </Route>

        <Route element={<PermissionRoute permission="notifications-list" />}>
          <Route path="/notifications" element={<NotificationsPage />} />
        </Route>
      </Route>

      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/home" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<CatchAllRoute />} />
    </Routes>
  )
}
